import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isError, ok } from "@nju/result";
import { IRepeatOrchestratorPaymentResult } from "./types";
import { verificationErrorResponse } from "./validators";

interface IRepeatOrchestratorPaymentProps {
  orchestratorId: string;
}

export async function repeatOrchestratorPayment({
  orchestratorId,
}: IRepeatOrchestratorPaymentProps): Promise<IRepeatOrchestratorPaymentResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/ORDER_PAYMENT_REPEAT`,
    {
      method: "post",
      json: {
        channel: "WEB",
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);

    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json,
    );

    if (errorInfo.success && errorInfo.data.code === "50133") {
      return err(
        new BasicError({
          message: "Funds on digital wallet are insufficient",
          code: "DW_INSUFFICIENT_FUNDS",
        }),
      );
    }

    return result;
  }

  return ok(undefined);
}
